import CustomeButton from "~/components/Button";
import PropTypes from "prop-types";

const TaskCommentSuccessView = ({
  Icon,
  Header,
  Description,
  onCancel,
  onNavigate,
}) => {
  return (
    <div className="task-comment-modal-content">
      <div className="header flex justify-content-end align-items-center">
        <i
          className="pi pi-times cross-icon mr-0"
          onClick={onCancel}
          style={{ cursor: "pointer" }}
        ></i>
      </div>

      <div className="flex flex-column justify-content-center align-items-center p-5">
        {Icon && <div className="empty__data__view--icon m-0">{Icon}</div>}
        <div className="flex gap-1 flex-column">
          {Header && (
            <p className="empty__data__view--header success-header m-0">
              {Header}
            </p>
          )}
          {Description && (
            <p className="empty__data__view--description success-description m-0">
              {Description}
            </p>
          )}
        </div>

        <div className="flex">
          <CustomeButton
            label="Back to Milestones"
            variant="outlined"
            onClick={onCancel}
          />
          <CustomeButton
            label="View Conversations"
            variant="contained"
            onClick={onNavigate}
          />
        </div>
      </div>
    </div>
  );
};

TaskCommentSuccessView.propTypes = {
  Icon: PropTypes.node,
  Header: PropTypes.string,
  Description: PropTypes.node,
  onCancel: PropTypes.func,
  onNavigate: PropTypes.func,
};

export default TaskCommentSuccessView;
